import { Typography, Box } from "@mui/material";
import { TableSimples } from "../../../../../components/BasicComponents/DisplayDados/TableSimples";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { IDataDashboardComercial } from "../../../../../types/api/comercial/dashboard";
import { useEffect, useState } from "react";
import moment from "moment";

import { formatarDecimalNumber } from "../../../../../helpers/masks";
import DateComIntervalo from "../../../../../components/DateComIntervalo";

export default function CardPrincipaisCompradores({
    dataDashboard,
    currentPeriodo,
    onChangePeriodo
}: CardPrincipaisCompradoresProps) {
    const defaultPeriodo = {
        inicial: moment().subtract(6, 'days').startOf('day'),
        final: moment().endOf('day')
    };

    const [selectedPeriodo, setSelectedPeriodo] = useState(currentPeriodo || defaultPeriodo);

    useEffect(() => {
        if (currentPeriodo) {
            setSelectedPeriodo(currentPeriodo);
        }
    }, [currentPeriodo]);

    function handleChangePeriodo(values: { inicial: moment.Moment | null; final: moment.Moment | null }): void {
        setSelectedPeriodo(values);

        if (typeof onChangePeriodo === 'function') {
            onChangePeriodo(values);
        }
    }

    return (
        <PaperBox style={{ height: '100%' }} p={2}>
            <Typography variant='h6'>Principais compradores</Typography>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                flexDirection={{ xs: "column", md: "row" }}
                gap={1}
                mb={2}
            >
                <Box width="300px">
                    <DateComIntervalo
                        size="small"
                        data={{
                            inicial: selectedPeriodo.inicial,
                            final: selectedPeriodo.final
                        }}
                        onChangeData={handleChangePeriodo}
                    />
                </Box>
            </Box>
            <TableSimples
                headers={[
                    { label: "Nome cliente" },
                    { label: "Loja" },
                    { label: "Valor total" },
                ]}
                rows={
                    dataDashboard.principais_compradores.map(row => ({
                        columns: [
                            { value: `${row.comprador}` },
                            { value: `${row.loja}` },
                            { value: formatarDecimalNumber(row.valor_total), numeric: true },
                        ]
                    }))}
            />
        </PaperBox>
    )
}
interface CardPrincipaisCompradoresProps {
    dataDashboard: IDataDashboardComercial;
    onChangePeriodo?: (values: { inicial: moment.Moment | null; final: moment.Moment | null }) => void;
    currentPeriodo?: { inicial: moment.Moment | null; final: moment.Moment | null };
}